export default {
    card: {
        title: 'Response privacy',
        description:
            'Choose whether {{managerPluralLabel}} will see the names of the people who answered the 360 feedback.',
        fixedDescription:
            'Shows whether {{managerPluralLabel}} will see the names of the people who answered the 360 feedback.',
        anonymous: {
            title: 'Anonymous',
            onlyCountShown: 'Only the number of respondents is shown',
            resultsFromMinimum_one: 'Results visible from {{count}} response',
            resultsFromMinimum_other: 'Results visible from {{count}} responses',
        },
        named: {
            title: 'Named',
            nameShown: 'Name shown with ratings and comments',
            resultsFromFirst: 'Results visible from the first response',
            followUp: 'Lets you talk it over in person with each respondent',
        },
        lockedNotice:
            'Response privacy can no longer be changed once the 360 feedback is launched.',
        inheritedTooltip: 'Set by the configured evaluation cycle. You cannot change this setting.',
    },
    anonymousMinimumRespondents_one:
        'An anonymous 360 feedback needs at least {{count}} respondent: its results only show from {{count}} response, so that no one can tell who answered.',
    anonymousMinimumRespondents_other:
        'An anonymous 360 feedback needs at least {{count}} respondents: its results only show from {{count}} responses, so that no one can tell who answered.',
    anonymousMinimumMissingFor: 'Add respondents for: {{names}}.',
    removalLocked:
        'This 360 feedback is anonymous and already launched: respondents can be added, but no longer removed, so that no one can tell who answered.',
    additionLocked: 'This 360 feedback is over: respondents can no longer be added.',
    namedExplanation:
        'Every answer is signed: you see who gave each rating and each comment. Results show from the first response.',
    label: {
        Anonymous: 'Anonymous feedback',
        Named: 'Named feedback',
    },
};
